/**
 * Small helpers shared by the template builder and its live preview.
 * Meta templates use positional placeholders: {{1}}, {{2}}, ...
 */

const VAR_RE = /\{\{\s*(\d+)\s*\}\}/g;

/** Number of distinct {{n}} placeholders in a string. */
export function countVariables(text = "") {
  const seen = new Set();
  let match;
  VAR_RE.lastIndex = 0;
  while ((match = VAR_RE.exec(String(text))) !== null) {
    seen.add(match[1]);
  }
  return seen.size;
}

/** Replace {{1}} with samples[0], {{2}} with samples[1], ... for the preview. */
export function fillVariables(text = "", samples = []) {
  return String(text).replace(VAR_RE, (whole, n) => {
    const value = samples[Number(n) - 1];
    return value && String(value).trim() ? value : whole;
  });
}

/** Split a string into text / {{n}} chunks so the preview can highlight vars. */
export function splitVariables(text = "") {
  return String(text).split(/(\{\{\s*\d+\s*\}\})/g).filter((p) => p !== "");
}

export const isVariableToken = (part = "") => /^\{\{\s*\d+\s*\}\}$/.test(part);
